var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"section-title",style:({'justify-content': _vm.alignment})},[(_vm.lineLeft)?_c('span',{staticClass:"section-title__line"}):_vm._e(),_c('span',{staticClass:"section-title__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }